<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Identificativi</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].display.label"
                          vid="display"
                          :label="beForm[rep].display.label"
                          v-model="form[rep].display"
                          placeholder="Inserisci un codice"
                          :rules="getRules('display')"
                          maxlength="3"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].importer_id.label"
                          vid="importer_id"
                          :label="beForm[rep].importer_id.label"
                          v-model="form[rep].importer_id"
                          @input="onInputImporterId"
                          :options="beForm[rep].importer_id.options"
                          :rules="getRules('importer_id')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].title.label"
                          vid="title"
                          label="Descrizione Compagnia"
                          v-model="form[rep].title"
                          placeholder="Inserisci una descrizione"
                          :rules="getRules('title')"
                        />
                      </div>
                      <div style="grid-column: 1/2" class="form-group">
                        <base-select
                          name="
                          exclude_calc_extra_vehicle_branch.label
                        "
                          vid="exclude_calc_extra_vehicle_branch"
                          label="
                          Escludi ricalcolo ramo danni extra auto
                        "
                          v-model="form.exclude_calc_extra_vehicle_branch"
                          :options="options"
                          :disabled="!form[rep].importer_id"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          name="exclude_calc_life_branch"
                          vid="exclude_calc_life_branch"
                          label="Escludi ricalcolo ramo vita"
                          v-model="form.exclude_calc_life_branch"
                          :options="options"
                          :disabled="!form[rep].importer_id"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          name="exclude_calc_vehicle_branch"
                          vid="exclude_calc_vehicle_branch"
                          label="Escludi ricalcolo ramo auto"
                          v-model="form.exclude_calc_vehicle_branch"
                          :options="options"
                          :disabled="!form[rep].importer_id"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Mandato</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          :name="beForm[mand_code].code.label"
                          vid="code"
                          label="Codice Mandato"
                          v-model="form[mand_code].code"
                          :rules="getRules('code', mand_code)"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[mand_code].title.label"
                          vid="title"
                          label="Descrizione Mandato"
                          v-model="form[mand_code].title"
                          :rules="getRules('title', mand_code)"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-card-wrapper">
                <b-card
                  header-tag="header"
                  class="mt-2"
                  v-if="canVerb('fattutto', 'config')"
                >
                  <template #header>
                    <b>Flusso contabilità fiscale</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-checkbox
                          name="fattutto_enabled"
                          groupLabel=""
                          :label="`Compagnia attiva all'esportazione per contabilità fiscale`"
                          v-model="form.fattutto.enabled"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          name="fattutto_code"
                          vid="fattutto_code"
                          label="Codice Compagnia per flusso esportazione contabilità fiscale"
                          class="custom-control-label"
                          v-model="form.fattutto.code"
                          placeholder="Inserisci un codice"
                          textcase="upper"
                          :rules="getCustomRules('fattutto_code')"
                        />
                      </div
                      >
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="mt-2" v-show="customInputs[rep].length">
                <div class="form-card-wrapper">
                  <b-card header-tag="header">
                    <template #header>
                      <b>Attributi personalizzati</b>
                    </template>
                    <b-card-text>
                      <custom-inputs
                        :customInputs="customInputs[rep]"
                        v-model="form[rep]"
                        :beForm="beForm[rep]"
                        :beRules="beRules[rep]"
                      />
                    </b-card-text>
                  </b-card>
                </div>
              </div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                    >Reset
                    </b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repositories/RepositoryFactory";
import CustomInputs from "@/components/form/CustomInputs";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
import {mapGetters} from "vuex";
import {canVerb} from "@/utils/permissions";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "insurer",
      id: this.$route.params.id,
      options: [
        {text: "Si", value: "Y"},
        {text: "No", value: "N"},
      ],
      form: {
        exclude_calc_extra_vehicle_branch: null,
        exclude_calc_life_branch: null,
        exclude_calc_vehicle_branch: null,
        fattutto: {
          code: "",
          enabled: false,
        },
        insurer: {
          display: null,
          importer_id: null,
          title: null,
        },
        mandate_code: {
          code: null,
          title: null,
          insurer_id: null,
          is_expired: "N",
        },
      },
    };
  },
  components: {
    CustomInputs,
    BaseCheckbox,
    BaseInput,
    BaseSelect,
  },
  methods: {
    canVerb,
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-companies-products-create":
            this.$router.push({
              name: "companies_products.create",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    getCustomRules(field) {
      let rules = {};
      if (field === "fattutto_code") {
        if (this.form.fattutto.enabled) {
          rules["required"] = true;
        } else {
          delete rules["required"];
        }
      }
      return rules;
    },
    endOfOnSubmit() {
      this.$showSnackbar({
        preset: "success",
        text: `Azione Completata: Compagnia Creata`,
      });
      this.shortcut("module.PROF", null, "#Companies", "filterInsurer");
    },
    onSubmit() {
      this.isLoading = true;
      this.store(this.repository)
        .then((response) => {
          const insurer_id = response?.data?.data?.id;
          this.addtoInsurer(
            response.data.data.id,
            "risk_type",
            this.setPayload()
          )
            .then((response) => {
              this.storeMandateCode(response.data.data.id);
              if (
                !this.form.fattutto.enabled &&
                !this.form.fattutto.code.length
              ) {
                this.endOfOnSubmit();
                return;
              }
              /* SAVE HERE FATTUTTO CONFIG with a new API call */
              const Repo = RepositoryFactory.get("fattutto");
              const payload = {
                configurable_id: insurer_id,
                configurable_type: "insurer",
                code: this.form.fattutto.code,
                ledger_type: 3, // no ledger_type
                // note: "",
                active: this.form.fattutto.enabled,
              };
              Repo.store_configuration(payload)
                .then(() => {
                  // this.$store.dispatch("auth/mandate_codes");
                  // this.$store.dispatch("auth/insurers");
                  this.endOfOnSubmit();
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                  // .finally(() => {
                  //   this.isLoading = false;
                  // });
                });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
              this.isLoading = false;
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    storeMandateCode(insurer_id) {
      this.form[this.mand_code].insurer_id = insurer_id;
      this.store(this.mand_code)
        .then(() => {
          this.$store.dispatch("auth/mandate_codes");
          this.$store.dispatch("auth/insurers");
          // this.$showSnackbar({
          //   preset: "success",
          //   text: `Azione Completata: Compagnia Creata`,
          // });
          // this.shortcut("module.PROF", null, "#Companies", "filterInsurer");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    defaultBranchConfig() {
      this.form.exclude_calc_extra_vehicle_branch = "N";
      this.form.exclude_calc_life_branch = "N";
      this.form.exclude_calc_vehicle_branch = "N";
    },
    onInputImporterId(val) {
      if (!val) {
        this.defaultBranchConfig();
      }
    },
    setPayload() {
      return {
        risk_type: {
          [this.getRisks().find((risk) => risk.code === "A").value]: {
            is_excluded: this.form.exclude_calc_vehicle_branch,
          },
          [this.getRisks().find((risk) => risk.code === "V").value]: {
            is_excluded: this.form.exclude_calc_life_branch,
          },
          [this.getRisks().find((risk) => risk.code === "D").value]: {
            is_excluded: this.form.exclude_calc_extra_vehicle_branch,
          },
        },
      };
    },
    addtoInsurer(insurer_id, relation, payload) {
      const Repo = RepositoryFactory.get("insurer");
      return Repo.pivot_store(insurer_id, relation, payload);
    },
    ...mapGetters("auth", {
      getRisks: "risks",
    }),
  },
  created() {
    this.isLoading = true;

    const ins = this.fetchCreateForm(this.repository);
    const mc = this.fetchCreateForm("mandate_code");

    // other form:
    Promise.all([ins, mc])
      .then(() => {
        this.defaultBranchConfig();

        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
    mand_code() {
      return "mandate_code";
    },
  },
};
</script>
